const QCF = {
  scrolled: 0,

  init() {
    QCF.events();
  },

  validate() {
    const formEl = $(".qcf__form");

    formEl.addClass("loading");
    $(".error", this).removeClass("error");

    if (helpers.validate(formEl, false)) {
      setTimeout(function () {
        QCF.recaptcha();
      }, 500);
    } else {
      formEl.removeClass("loading");
    }
  },

  events() {
    $(".qcf__form").on("submit", (e) => {
      e.preventDefault();
      QCF.validate();
    });

    // Close error.
    $("body").on("click", ".qcf-message button", () => {
      $(".qcf__form .qcf-message").removeClass(
        "qcf-message--active qcf-message--error"
      );
    });

    // Open.
    $("body").on("click", ".qcf__button", () => {
      $(".qcf .qcf__popup").addClass("qcf__popup--active");
      QCF.scrolled = $(window).scrollTop();
      $("html").addClass("no-scroll");
      $("body").scrollTop(QCF.scrolled);
    });

    // Close on click outside.
    $("body").on("click", ".js-close", () => {
      $(".qcf .qcf__popup").removeClass("qcf__popup--active");
      $("html").removeClass("no-scroll").scrollTop(QCF.scrolled);
    });

    // Close on ESC.
    $(document).on("keydown", (e) => {
      if (e.key == "Escape") {
        $(".qcf .qcf__popup").removeClass("qcf__popup--active");
        $("html").removeClass("no-scroll").scrollTop(QCF.scrolled);
      }
    });
  },

  recaptcha() {
    if (typeof window._solepharmWhenRecaptchaReady === "function") {
      window._solepharmWhenRecaptchaReady((ready) => {
        if (ready && typeof grecaptcha !== "undefined") {
          grecaptcha.ready(() => {
            grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
              QCF.submit(token);
            });
          });
        } else {
          const formEl = $(".qcf__form");
          formEl.removeClass("loading");
          const msg = (typeof translations !== "undefined" && translations.recaptcha_consent_required) || "Please enable Preferences cookies to use this form.";
          formEl.find(".qcf-message h4").text(msg);
          formEl.find(".qcf-message").addClass("qcf-message--active qcf-message--error");
        }
      });
      return;
    }
    grecaptcha.ready(() => {
      grecaptcha.execute(recaptcha_key, { action: "submit" }).then((token) => {
        QCF.submit(token);
      });
    });
  },

  submit(token) {
    const formEl = $(".qcf__form");

    const messageEl = formEl.find(".qcf-message");

    const formData = new FormData(formEl[0]);
    formData.append("token", token);

    messageEl.removeClass(
      "qcf-message--active qcf-message--error qcf-message--success"
    );

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: formData,
      processData: false,
      contentType: false,
    }).done(function (response) {
      formEl.removeClass("loading");

      if (response.success) {
        formEl[0].reset();

        formEl.find("input, textarea").blur();
        messageEl.find("h4").text(translations.form_success);
        messageEl.addClass("qcf-message--active qcf-message--success");
      } else {
        messageEl.find("h4").text(translations.form_error);
        messageEl.addClass("qcf-message--active qcf-message--error");
      }
    });
  },
};

export default QCF;
